<template>
  <div
    :aria-checked="checked"
    class="checkbox"
    role="checkbox"
    tabindex="0"
    @click="onToggle"
    @keydown.space="handleSpaceKey"
  >
    <label class="item">
      <label :for="id" class="checkbox__label" />
      <input :id="id" :checked="checked" type="checkbox" hidden />
      <span :for="id" class="checkmark" />
    </label>
  </div>
</template>

<script>
export default {
  name: 'CheckboxGeneralDropdown',
  props: {
    id: {
      validator: (prop) => typeof prop === 'string' || prop == null,
      required: true
    },
    checked: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle'],
  methods: {
    handleSpaceKey(event) {
      event.preventDefault()
      this.onToggle()
    },
    onToggle() {
      if (!this.disabled) this.$emit('toggle', this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss';

.checkbox {
  display: block;
  width: 14px;
  height: 14px;
  background-color: variables.$color-grey-lighter;
  border-radius: 2px;
  position: relative;
  transition: background-color 0.4s;
  cursor: pointer;
  border: 0.5px solid variables.$color-grey-lighter;
  box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
}

.checkmark {
  cursor: pointer;
}

.checkbox .checkmark:after {
  content: '';
  position: absolute;
  width: 4px;
  height: 9px;
  border-right: 1.5px solid variables.$color-grey-darker;
  border-bottom: 1.5px solid variables.$color-grey-darker;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%) rotateZ(40deg) scale(4);
  transition: all 0.4s;
  opacity: 0;
  pointer-events: none;
}

.checkbox input:checked ~ .checkmark:after {
  opacity: 1;
  transform: translate(-50%, -50%) rotateZ(40deg) scale(1);
}

.checkbox input:checked ~ .checkmark {
  background-color: variables.$color-grey-lighter;
}
</style>
